export const removeAllCommasExceptFirst = (val: string) =>
  val.replace(/^([^.]*\.)(.*)$/, (a, b, c) => b + c.replace(/\./g, ''));
